import {OnInit,Component,ViewChild,AfterViewInit, signal,} from '@angular/core';
import { Utils } from 'src/app/utils/utils';//usado

import { AppComponent } from 'src/app/app.component';
import { NumberUtils } from 'src/app/utils/number-utils';
import { MainComponent } from '../../main/main.component';//usado
import { environment } from 'src/environments/environment';
import { HeaderComponent } from '../../header/header.component';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';



import { NzModalService } from 'ng-zorro-antd/modal';
import { SsoService } from 'src/app/services/sso/sso.service';//usado
import { FlotaService } from 'src/app/services/flota/flota.service';//usado
import { ResourcesService } from 'src/app/services/resources/resources.service';

import { MovilModel } from 'src/app/services/resources/models/movil.model';//usado
import { SubflotaModel } from 'src/app/services/flota/models/subflota.model';
import { RendererUtils } from 'src/app/utils/RendererUtils';
import { WindowComponent } from 'movisat-common-gui';


@Component({
  selector: 'app-subflotas',
  templateUrl: './subflotas.component.html',
  styleUrls: ['./subflotas.component.css']
})
export class SubflotasComponent  implements OnInit, AfterViewInit {
  @ViewChild('grid') protected grid: jqxGridComponent;
  @ViewChild('form') public form: WindowComponent;
  @ViewChild('header') protected header: HeaderComponent;
  @ViewChild('loader') protected loader: jqxLoaderComponent;//esto se cambia por el propio
  @ViewChild('ebNombre') protected ebNombre: jqxInputComponent;//esto
  @ViewChild('gridMoviles1') protected gridMoviles1: jqxGridComponent;//esto
  @ViewChild('gridMoviles2') protected gridMoviles2: jqxGridComponent;//esto

  public static _this: SubflotasComponent;

  private componentRef = null;
  public environment = environment;
  public subflotas: SubflotaModel[] = [];//usado
  public subflotaSelec: SubflotaModel = null;//usado
  public subflotaEdit: SubflotaModel = null;//usado
  public movilesLibres: MovilModel[]=[];
  public mostrarEditForm = false;
  public canEdit = true;
  private showRowDetails: number[] = [];

  protected loading = signal(false);

  // Variables para el grid de subflotas
  public sourceSubflotas: any = [];
  public dataAdapterSubflotas = new jqx.dataAdapter(this.sourceSubflotas);

   public createTooltip = (content: string) => {
    return (columnHeaderElement?: any) => {
      const jqElement = columnHeaderElement[0].parentElement;
      const options = {
        content: content,
        theme: environment.tema,
        width: 'auto',
        height: 'auto',
        position: 'mouse',
        autoHide: true,
      };
      return jqwidgets.createInstance(jqElement, 'jqxTooltip', options);
    };
  };

  protected actions = [
    {type: "button", action:"salir", value: "", label: this.translate('Salir')},

  ];
  public  actionButtonClicked(event): void{
    if(event.action === 'salir') {
      this.onClose();
      return;
    }

  }

  public columnsMoviles = [
    { text: AppComponent.translate('Icono'), datafield: 'icono', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Icono')) },
    {
      text: AppComponent.translate('CODIGO'), datafield: 'codigo', cellsrenderer: RendererUtils.numberrenderer, rendered: this.createTooltip(AppComponent.translate('CODIGO')),
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
            aggregates["Total"] + ' </div>';
        }
        return renderstring;
      }
    },
    { text: AppComponent.translate('Matricula'), datafield: 'matricula', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Matricula')) },
    { text: AppComponent.translate('Nombre'), datafield: 'nombre', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Nombre')) },
    { text: AppComponent.translate('Recurso'), datafield: 'recurso', filtertype: 'checkedlist', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Recurso')) },
    { text: AppComponent.translate('Clase'), datafield: 'clase', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Clase')) },
    { text: AppComponent.translate('Base'), datafield: 'base', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Base')) },
  ];

  // Variables para el grid de resto de flota
  public movilesResto: MovilModel[] = [];

  protected numberrend(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      return (
        '<div class="jqx-grid-cell-right-align" style="height: 100%; display: flex;justify-content: flex-end; align-items: center;">' +
        NumberUtils.format(value, 0) +
        '</div>'
      );
    } else if (value === 0) {
      return (
        '<div class="jqx-grid-cell-right-align" style="height: 100%; display: flex;justify-content: flex-end; align-items: center;">' +
        NumberUtils.format(value, 0) +
        '</div>'
      );
    }
  }

  public movilesSubflota: MovilModel[] = [];

  public langGrid = JqWidgets.getLocalization('es');

  public constructor(
    private flotaService: FlotaService,
    private resourcesService: ResourcesService,//usado
    private ssoService: SsoService,//usado
    private modal: NzModalService,
  ) {
    SubflotasComponent._this = this;
  }

  public ngOnInit(): void {
    this.canEdit = true;
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
  }

  public ngOnDestroy(): void {
    if (this.grid) {
      this.grid.destroy();
    }
  }

  public ngAfterViewInit(): void {
    // Creo una subflota vacia para rellenar
    this.subflotaEdit = this.getEmptySubflota();
    // Recupero las subflotas
    this.getSubflotas();
  }

  // Este método es llamado por el creador del componente
  public init(componentref: any): void {
    this.componentRef = componentref;
  }

  public closeWindow(): void  {
    this.form.closeWindow();
  }

  // Para traducir los textos del template
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public columnsSubflotas = [
    { text: '', datafield: 'id', hidden: true },
    {
      text: '',
      width: 60,
      columntype: 'text',
      sortable: false,
      editable: false,
      resizable: false,
      filterable: false,
      datafield: 'acciones',
      groupable: false,
      menu: false,
        rendered: (columnHeaderElement: any[]):void => {
        const date = new Date();
        const time = date.getTime().toString();
        const buttonContainer = document.createElement('div');

        const options = {
          width: '100%',
          value: '<i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>',
          textImageRelation: 'imageAboveText',
        };

        buttonContainer.id = `buttonContainerColumn_jqxButton`;
        columnHeaderElement[0].appendChild(buttonContainer);
        let myButton;

        setTimeout(() => {
          myButton = jqwidgets.createInstance(
            `#buttonContainerColumn_jqxButton`,
            'jqxButton',
            options
          );

          myButton.addEventHandler('click', () => {
            this.onCrearSubflotaClick()
          });

          try {
            const btn = <HTMLElement>buttonContainer.parentElement.children[2];
            btn.title = this.translate('Aniadir');
            btn.classList.add('button');
            btn.style.cursor = 'pointer';
            btn.style.width = '100%';
            btn.style.height = '25px';
            btn.style.display = 'flex';
            btn.style.justifyContent = 'center';
            btn.style.alignItems = 'center';

            const icon = <HTMLElement>btn.children[1];
            icon.style.position = 'unset';
          } catch (error) {
            console.debug(error);
          }
        }, 100);
        return columnHeaderElement[0];
      },
      createwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement
      ): void => {
        this.initBtnColumn(row, column, value, htmlElement);
      },
      initwidget: (
        row: any,
        column: any,
        value: string,
        htmlElement: HTMLElement
      ):void => {
        this.initBtnColumn(row, column, value, htmlElement);
      }
    },
    {
      text: AppComponent.translate('Nombre'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 200, cellsrenderer: RendererUtils.rendexTextGeneric, rendered: this.createTooltip(AppComponent.translate('Nombre'))
    },
    {
      text: AppComponent.translate('Moviles'), columntype: 'textbox', filtertype: 'textbox', datafield: 'totMoviles', width: 85, align: 'center', cellsrenderer: RendererUtils.numberrenderer, rendered: this.createTooltip(AppComponent.translate('Moviles')),
      cellsalign: 'right',
    },
    {
      text: AppComponent.translate('Observaciones'), columntype: 'textbox', filtertype: 'textbox', datafield: 'observ', width: 300, cellsrenderer: RendererUtils.rendexTextGeneric, rendered: this.createTooltip(AppComponent.translate('Observaciones'))
    },
    { text: 'Selec', columntype: 'textbox', filtertype: 'textbox', datafield: 'selec', hidden: true }
  ];

  // Incializa la columna de botones
  public async initBtnColumn(
    row: any,
    column: any,
    value: string,
    htmlElement: HTMLElement
  ): Promise<void> {
    htmlElement.innerHTML = '';
    // Crea un contenedor para los botones
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.justifyContent = 'space-around';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';

    let rowdata: any;
    if (isNaN(row)) {
      rowdata = row.bounddata;
    } else {
      rowdata = this.grid.getrowdata(row);
    }

    if (rowdata.id !== 0) {
      const btnEdit = document.createElement('div');
      btnEdit.innerHTML = `
          <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Editar') + `">
            <i class="fa-solid fa-pen-to-square"></i>
          </button>
        `;
      btnEdit.id = `buttonEdit_jqxButton`;
      btnContainer.appendChild(btnEdit);

      btnEdit.addEventListener('click', async (event: any) => {
        this.onEditarSubflotaClick()
      });
      htmlElement.appendChild(btnContainer);
    }

    if (!(rowdata?.totMoviles) || rowdata?.totMoviles === 0) {
      const btnDelete = document.createElement('div');
      btnDelete.innerHTML = `
        <button class="button" style="height: 23px; width: 25px; padding: 0; margin: 0; cursor: pointer !important;" title="`+ AppComponent.translate('Borrar') + `">
          <i class="fa-solid fa-trash"></i>
        </button>
      `;
      btnDelete.id = `buttonDelete_jqxButton`;
      btnContainer.appendChild(btnDelete);

      btnDelete.addEventListener('click', async (event: any) => {
        this.onBorrarSubflotaClick();
      });
    }
  }

  public rowdetailstemplate = (index: any):  any=> {
    const date = new Date();
    const time = date.getTime().toString();
    const details = {
      rowdetails: `<div id="detailsSubflota${time}" style="margin: 10px;"></div>`,
      rowdetailshidden: true,
    };
    return details;
  };

   public initRowDetails = async (index: any,
    parentElement: any,
    gridElement: any,
    datarecord: any): Promise<void> => {
    if (parentElement && datarecord) {
      const nestedGridContainer = parentElement.children[0];
      const moviles = this.subflotas.find(subflota => subflota.Id === datarecord.id).Moviles;
      if (moviles) {
        moviles.forEach(movil => {
          let clasesString = '';

          if (movil && movil.ConjuntoVehiculo && movil.ConjuntoVehiculo.Clases) {
            movil.ConjuntoVehiculo.Clases.forEach(clase => {
              if (clase) {
                clasesString += clasesString == '' ? clase.Nombre : ', ' + clase.Nombre;
              }
            });
          }

          movil['clasesText'] = clasesString;
        });

        const columnasMoviles = [
          { text: AppComponent.translate('Icono'), datafield: 'icono', cellsrenderer: this.rendeCell, filterable: false, sortable: false, rendered: this.createTooltip(AppComponent.translate('Icono')) },
          { text: AppComponent.translate('CODIGO'), datafield: 'codigo', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('CODIGO')) },
          { text: AppComponent.translate('Matricula'), datafield: 'matricula', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Matricula')) },
          { text: AppComponent.translate('Nombre'), datafield: 'nombre', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Nombre')) },
          { text: AppComponent.translate('Recurso'), datafield: 'recurso', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Recurso')) },
          { text: AppComponent.translate('Clase'), datafield: 'clase', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Clase')) },
          { text: AppComponent.translate('Base'), datafield: 'base', cellsrenderer: this.rendeCell, rendered: this.createTooltip(AppComponent.translate('Base')) },
        ];

        const sourceMoviles = {
          datatype: 'json',
          datafields: [
            { name: 'icono', map: 'ConjuntoVehiculo>Icono' },
            { name: 'codigo', map: 'Codigo' },
            { name: 'matricula', map: 'Matricula' },
            { name: 'nombre', map: 'Nombre' },
            { name: 'recurso', map: 'TipoMovil>Nombre' },
            { name: 'clase', map: 'clasesText' },
            { name: 'base', map: '' },
          ],
          localdata: moviles,
        };

        const dataAdapterMoviles = new jqx.dataAdapter(sourceMoviles);

        if (nestedGridContainer != null) {
          const setting = {
            width: '97%',
            height: 180,
            source: dataAdapterMoviles,
            theme: this.environment.tema,
            columns: columnasMoviles,
            localization: this.langGrid,
            editable: false,
            sortable: true,
            filterable: true,
            selectionmode: 'none'
          };

          const gridDetail = jqwidgets.createInstance(
            `#${nestedGridContainer.id}`,
            'jqxGrid',
            setting
          );

          setTimeout(() => {
            this.resizeGridDetails(gridDetail);
          }, 100);
        }
      }
    }
  }

  public rendeCell(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (columnfield === 'icono') {
      return `
        <img style="margin-left: 4px; margin-top: 6px;" height="16" width="16" src="data:image/jpg;base64,${value}"/>
      `;
    }
    return `
      <div style="margin-left: 4px; margin-top: 5px;  text-align: left;""
      onmouseover="this.style.backgroundColor='gray'; this.style.color='white'; this.style.position='fixed'"
      onmouseout="this.style.backgroundColor=''; this.style.color=''; this.style.position=''">
        ${value}
      </div>
    `;
  }

  public resizeGridDetails(grid: jqxGridComponent): void {
    if (grid) {
      grid.setOptions({
        columnsheight: 20,
        statusbarheight: 20,
        rowsheight: 22,
        columnsresize: true,
      });
    }
  }

 public async getSubflotas():Promise<void> {
  this.loading.set(true);
    try {
      this.columnsSubflotas.forEach(column => {
        if (column.datafield !== 'acciones') {
          column.rendered = (element):void => { Utils.tooltiprenderer(element) };
        }
      });

      this.subflotaSelec = null;
      this.subflotas = await this.flotaService.getSubflotas();
      if (this.subflotas) {
        this.movilesLibres=this.subflotas.find(subflota=>subflota.Id===0)?.Moviles||[];

        const customSortByMoviles = (a: any, b: any) => {
          return a['totMoviles'] - b['totMoviles'];
        };
        this.subflotas.sort(customSortByMoviles);
        this.sourceSubflotas = {
          datatype: 'json',
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          sort: customSortByMoviles as any,
          datafields: [
            { name: 'id', type: 'string', map: 'Id' },
            { name: 'nombre', type: 'string', map: 'Nombre' },
            { name: 'totMoviles', type: 'number', map: 'MovilesId>length' },
            { name: 'observ', type: 'string', map: 'Observaciones' },
            { name: 'selec', map: 'selec' }
          ],
          localdata: this.subflotas,
        };
        this.dataAdapterSubflotas = new jqx.dataAdapter(this.sourceSubflotas);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading.set(false);
    }
  }

  public subflotaBindingComplete():void {
    this.setTotMovilesText();
  }

  // Genera el texto para la cabecera del total de moviles
  public setTotMovilesText():void {
    const column= this.columnsSubflotas.find(col => col.datafield === 'totMoviles');
    let total = 0;
    this.grid.getrows().forEach(row => {
      total += row.totMoviles;
    }
    )

    this.grid.setcolumnproperty('totMoviles', 'text', AppComponent.translate('Moviles') + ' (' + total + ')');
  }

  public onSort(event: any):void {
    this.showRowDetails.forEach(row => {
      this.grid.getrows().forEach(elem => {
        if (row === elem.id) {
          this.grid.showrowdetails(elem.boundindex)
        }
      });
    });
  }

  public rowexpand(event: any):void {
    const id = this.grid.getrowdata(event.args.rowindex).id;
    if (!(this.showRowDetails.includes(id))) {
      this.showRowDetails.push(id);
    }
  }

  public rowcollapse(event: any):void {
    const id = this.grid.getrowdata(event.args.rowindex).id;
    this.showRowDetails.splice(this.showRowDetails.indexOf(id), 1);
  }

  //seccion de filtros
  public eventFilter():void {
    this.header.searchInput['nativeElement'].value = '';
    this.getSubflotas();
  }

  public eventResetFilter():void {
    this.header.searchInput['nativeElement'].value = '';
    this.onBuscar();
  }

  public onBuscar():void  {
    let filtervalue = '';

    if (this.header.searchInput['nativeElement'].value.length >= 3) {
      filtervalue = this.header.searchInput['nativeElement'].value.toUpperCase();
    } else {
      filtervalue = '';
    }

    this.subflotas.forEach(cal => {
      if (
        (cal?.Nombre + '').compareWith(filtervalue) ||
        (cal?.Observaciones + '').compareWith(filtervalue)
      ) {
        cal['selec'] = 'selec';
      } else {
        cal['selec'] = '';
      }
    });

    // Compruebo si ya he creado el filtro "selec" anteriormente
    const filters = this.grid.getfilterinformation();
    if (filters.find(s => s.datafield === 'selec') === undefined) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';
      filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
      this.grid.addfilter('selec', filtergroup);
    }
    try {
      this.grid.applyfilters();
    } catch (error) {
      console.log(error);
    }
    try {
      this.grid.updatebounddata('data');
    } catch (error) {
      console.log(error);
    }

    this.setTotMovilesText();
  }

 public  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    const filterColumns = [
      'nombre',
      'observ',
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  // Cierro el formulario y destruyo el componente
  public async onClose(): Promise<void> {
    if (this.componentRef) {
      this.form.disableWindow();
      this.componentRef.destroy();
    }

    SubflotasComponent._this = null;
  }

  // Crea una subflota sin datos
 public  getEmptySubflota(): SubflotaModel {
    const subflota = new SubflotaModel();
    subflota.Id = 0;
    subflota.EmpresaId = this.ssoService.getTicket().Empresa.IdGestion;
    subflota.Nombre = '';
    subflota.Observaciones = '';
    subflota.MovilesId = [];
    return subflota;
  }

  public async  onRowSubflotaSelect(event: any): Promise<void> {
    this.subflotaSelec = this.subflotas[event.args.rowindex];
  }

 public async  onRowdoubleclick(event: any): Promise<void> {
    if (event.args.row.rowdetails) {
      this.subflotaSelec = this.subflotas[event.args.rowindex];
      this.onEditarSubflotaClick();
    }
  }

  // Crear una nueva subflota
  public async onCrearSubflotaClick(): Promise<void> {
    if (!this.canEdit) {
      return;
    }
    // Creo una subflota vacía para rellenar
    this.subflotaEdit = this.getEmptySubflota();
    this.mostrarEditForm = true;
    this.form.collapseWindow();
    this.form.disableWindow();
  }

  // Editar la subflota seleccionada
 public async  onEditarSubflotaClick(): Promise<void> {
    if (this.subflotaSelec) {
      this.subflotaEdit = { ...this.subflotaSelec };
      if (this.form !== undefined) {
        this.form.collapseWindow();
        this.form.disableWindow();
      }
      this.mostrarEditForm = true;
    } else {
      MainComponent.getInstance().showError('ATENCION', 'Seleccione_registro', 2000);
    }
  }

  // Borrar la subflota seleccionada
  public async onBorrarSubflotaClick(): Promise<void> {
    if (!this.canEdit || this.subflotaSelec.Id === 0) {
      return;
    }
    if (this.subflotaSelec !== null) {
      this.deleteSubflota();
    } else {
      MainComponent.getInstance().showError('ATENCION', 'Seleccione_registro', 2000);
    }
  }

  // Guardo la subflota
  public async updateGrid(subflota: SubflotaModel): Promise<void> {

      const index = this.subflotas.findIndex(item => item.Id === subflota.Id);
      if (index !== -1) {
        this.subflotas[index] = subflota;
      } else {
        this.subflotas.push(subflota);
      }
         this.getSubflotas();

  }

  public async deleteSubflota(): Promise<void> {
    this.modal.confirm({
      nzTitle: '<i>' + AppComponent.translate('ATENCION') + '</i>',
      nzContent: AppComponent.translate('Borrar_subflota') + ': ' + this.subflotaSelec.Nombre + ' ?',
      nzCentered: true,
      nzCancelText: AppComponent.translate('CANCELAR'),
      nzOkText: AppComponent.translate('SI'),
      nzOnOk: async () => {
        const result = await this.flotaService.deleteSubflota(this.subflotaSelec.Id);
        if (result) {
          for (let i = 0; i < this.subflotas.length; i++) {
            if (this.subflotas[i].Id === this.subflotaSelec.Id) {
              this.subflotas.splice(i, 1);
              break;
            }
          }
          this.subflotaSelec = null;
          this.grid.updatebounddata('data');
          MainComponent.getInstance().showSuccess('ATENCION', 'Registro_borrado', 2000);
        }
      }
    });
  }

  public  onCloseEdit(): void {
    this.mostrarEditForm=false;
    if (this.form !== undefined) {
      this.form.enableWindow();
      this.form.expandWindow();
    }
  }

}
